import PlotItemPage from "@/components/tables/plotItem/PlotItem.vue";
import MapModal from "@/components/common/mapModal/Index";
const newGroupingPage = () => import("./newGroupingPage");
const ImageResources = () => import("@/components/tables/resources/Index.vue");
import {
  getPlotItemGroupListService,
  deteleBimPlottedData,
  plotCheckBeforeAddList,
  clonePlotData,
} from "@/api/api.js";
import * as plotOperation from "@/components/tables/plotItem/plotConfig.js";
export default {
  name: "plotTree",
  components: {
    MapModal,
    newGroupingPage,
    PlotItemPage,
    ImageResources,
  },
  data() {
    return {
      plotItem: {
        title: "标绘树",
        id: "plotItem",
      },
      modalNode: {
        plotItem: {
          show: true,
          loading: false,
          width: "380px",
          height: `${
            document.querySelector("#mars3d-container").offsetHeight - 140
          }px`,
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "shpTree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            expand: true,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            currentNodeKey: "",
            checkeArr: [],
            search: {
              keywords: "text", // 搜素配置关键字 默认是name
            },
            checkBox: true,
            checkBoxClick: this.checkBoxClick,
            nodeClick: this.nodeClick,
          },
        },
      },
      newPageShow: false,
      plotItemShow: false,
      imageResourcesShow: false,
      groupProps: {
        title: "新建分组",
        id: null,
        name: null,
      },
      currentNode: null,
      checkedIds: [],
      posCode: window.sessionStorage.getItem("posCode"),
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    clonePlotDataMethod(val) {
      clonePlotData({
        id: val.id,
        projectId: Number(sessionStorage.getItem("nowProjectId")),
        scenesId: "",
      }).then((res) => {
        this.$notify({
          title: `复制成功！`,
          message: "",
          type: "success",
          duration: 960,
          offset: 320,
        });
        this.getData();
      });
    },
    setIcon(data) {
      switch (data.bimPlanPainting.shapeType) {
        case 1:
          data.i_icon = "las la-dot-circle";
          break;
        case 2:
          data.i_icon = "las la-slash";
          break;
        case 3:
          data.i_icon = "las la-th-large";
          break;
        case 4:
          data.i_icon = "las la-cube";
          break;
        default:
          data.i_icon = "";
      }
    },
    // 获取标绘分组数据
    getData() {
      this.modalNode.plotItem.content.checkeArr = this.checkedIds;
      const params = {
        ProjectId: sessionStorage.getItem("nowProjectId"),
        DataType: 1,
      };
      getPlotItemGroupListService(params).then((res) => {
        plotOperation.getProjectPlotTreeData(res.data.data);
        // 一级分组：编辑删除
        let operateGroupingList = [];
        if (this.posCode != "guest") {
          operateGroupingList = [
            {
              i_icon: "small-operation-btn el-icon-plus",
              click: (e) => this.groupAddPlot(e),
            },
            {
              i_icon: "small-operation-btn el-icon-edit",
              click: (e) => this.editGroupName(e),
            },
            {
              i_icon: "small-operation-btn el-icon-delete",
              click: (e) => this.deleteGroup(e),
            },
          ];
        }
        let operateGroupingListSecond = [];
        if (this.posCode != "guest") {
          // 二级数据：编辑删除
          operateGroupingListSecond = [
            {
              i_icon: "small-operation-btn el-icon-edit",
              click: (e) => this.editPlotData(e),
            },
            {
              i_icon: "small-operation-btn el-icon-copy-document",
              click: (e) => this.clonePlotDataMethod(e),
            },
            {
              i_icon: "small-operation-btn el-icon-delete",
              click: (e) => this.deletePlot(e),
            },
          ];
        }

        if (res.data.data.length > 0) {
          res.data.data.forEach((item) => {
            item.operate = operateGroupingList;
            if (item.children.length > 0) {
              item.children.forEach((etem) => {
                etem.operate = operateGroupingListSecond;
                this.setIcon(etem);
              });
            }
          });
          this.modalNode.plotItem.content.treeDataJson = res.data.data;
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.plotTree.$refs.modalTree[0].setCurrentKey(
                res.data.data[0].id
              );
              this.currentNode = res.data.data[0].id;
            }, 1000);
          });
        }
      });
    },
    // 刷新
    getData2() {
      this.modalNode.plotItem.content.checkeArr = this.checkedIds;
      const params = {
        ProjectId: sessionStorage.getItem("nowProjectId"),
        DataType: 1,
      };
      getPlotItemGroupListService(params).then((res) => {
        plotOperation.getProjectPlotTreeData(res.data.data);
        // 一级分组：编辑删除
        const operateGroupingList = [
          {
            i_icon: "small-operation-btn el-icon-plus",
            click: (e) => this.groupAddPlot(e),
          },
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.editGroupName(e),
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: (e) => this.deleteGroup(e),
          },
        ];
        // 二级数据：编辑删除
        const operateGroupingListSecond = [
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.editPlotData(e),
          },
          {
            i_icon: "small-operation-btn el-icon-copy-document",
            click: (e) => this.clonePlotDataMethod(e),
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: (e) => this.deletePlot(e),
          },
        ];
        if (res.data.data.length > 0) {
          res.data.data.forEach((item) => {
            item.operate = operateGroupingList;
            if (item.children.length > 0) {
              item.children.forEach((etem) => {
                etem.operate = operateGroupingListSecond;
                this.setIcon(etem);
              });
            }
          });

          this.modalNode.plotItem.content.treeDataJson = res.data.data;
          this.$nextTick(() => {
            this.$refs.plotTree.$refs.modalTree[0].setCurrentKey(
              this.currentNode
            );
          });
        }
      });
    },
    // 分组刷新
    getNewGroupData() {
      this.modalNode.plotItem.content.checkeArr = this.checkedIds;
      const params = {
        ProjectId: sessionStorage.getItem("nowProjectId"),
        DataType: 1,
      };
      getPlotItemGroupListService(params).then((res) => {
        // 把当前场景下的所有标绘值存储
        plotOperation.getProjectPlotTreeData(res.data.data);
        // 一级分组：编辑删除
        const operateGroupingList = [
          {
            i_icon: "small-operation-btn el-icon-plus",
            click: (e) => this.groupAddPlot(e),
          },
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.editGroupName(e),
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: (e) => this.deleteGroup(e),
          },
        ];
        // 二级数据：编辑删除
        const operateGroupingListSecond = [
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.editPlotData(e),
          },
          {
            i_icon: "small-operation-btn el-icon-copy-document",
            click: (e) => this.clonePlotDataMethod(e),
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: (e) => this.deletePlot(e),
          },
        ];
        if (res.data.data.length > 0) {
          res.data.data.forEach((item) => {
            item.operate = operateGroupingList;
            if (item.children.length > 0) {
              item.children.forEach((etem) => {
                this.setIcon(etem);
                etem.operate = operateGroupingListSecond;
              });
            }
          });
          this.modalNode.plotItem.content.treeDataJson = res.data.data;
          this.$nextTick(() => {
            this.currentNode = res.data.data[res.data.data.length - 1].id;
            this.$refs.plotTree.$refs.modalTree[0].setCurrentKey(
              res.data.data[res.data.data.length - 1].id
            );
          });
        }
      });
    },
    // 打开添加分组
    addGrouping() {
      this.groupProps = {
        title: "新建分组",
        id: null,
        name: null,
      };
      this.imageResourcesShow = false;
      this.plotItemShow = false;
      this.newPageShow = true;
    },
    // 取消关闭分组
    closeNewGrouping() {
      this.newPageShow = false;
    },
    // 添加分组提交
    onSubmitGroupName() {
      this.currentNode = null;
      this.getNewGroupData();
      this.newPageShow = false;
    },
    // 删除分组
    deleteGroup(e) {
      this.$confirm("您确定要删除此分组吗？", "确认提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        deteleBimPlottedData({ id: e.id }).then((res) => {
          this.$notify({
            title: `删除成功！`,
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
          if (e.children.length > 0) {
            e.children.forEach((item) => {
              this.deleteGroupPlotData(item);
            });
          }
          this.currentNode = null;
          this.getData();
        });
      });
    },
    // 编辑分组名
    editGroupName(e) {
      this.groupProps = {
        title: "编辑分组",
        id: e.id.toString(),
        name: e.text,
      };
      this.newPageShow = true;
    },
    // 一级分组下点击加号时
    groupAddPlot(e) {
      this.currentNode = e.id;
      this.addPlot();
    },
    // 点击新增标绘时
    addPlot() {
      if (!this.currentNode) {
        this.$notify({
          title: `请先选择分组`,
          message: "",
          type: "warning",
          duration: 960,
          offset: 320,
        });
        return false;
      }
      this.modalNode.plotItem.head.fold.state = false;
      this.newPageShow = false;
      this.imageResourcesShow = false;
      this.plotItemShow = true;
      this.$refs.PlotItemPage.deletePlotItemLayer();
    },
    // 编辑标绘
    editPlotData(data) {
      // 先把分组节点传过去
      this.currentNode = data.parentId;
      // 收缩分组列表
      this.modalNode.plotItem.head.fold.state = false;
      // 打开标绘弹出层
      this.plotItemShow = true;

      this.$refs.PlotItemPage.deletePlotItemLayer();
      this.$GLOBAL.plotItemLayer.stopEditing();
      plotOperation.operationPlotData(true, data.id);
      this.$nextTick(() => {
        this.$refs.PlotItemPage.resourcesHttp(data.dataType, data.pId);
      });
      const oldGraphic = this.$GLOBAL.plotItemLayer.getGraphicById(
        JSON.parse(data.bimPlanPainting.graphic).id
      );
      // 有旧数据并且存在图层中
      if (oldGraphic) {
        oldGraphic.startEditing();
        const model = plotOperation.manageFields(data);

        // 显示对应的属性编辑，传递form数据
        this.$refs.PlotItemPage.initFormData(
          data.bimPlanPainting.customType,
          JSON.parse(data.bimPlanPainting.graphic).id
        );
        this.$refs.PlotItemPage.initItemsArr(data.bimPlanPainting.customType);
        this.$refs.PlotItemPage.editMergeForm(model, data.dataType, data.pId);
      } else {
        // 没有旧数据去查
        const graphic = plotOperation.flyToPlot(data.id, "edit");
        if (graphic) {
          // 开启编辑（支持拖动）
          graphic.drawGraphic.startEditing();
          // 显示对应的属性编辑，传递form数据
          this.$refs.PlotItemPage.initFormData(
            graphic.current.bimPlanPainting.customType,
            graphic.current.uid
          );
          this.$refs.PlotItemPage.initItemsArr(data.bimPlanPainting.customType);
          const data = plotOperation.manageFields(graphic.current);
          this.$refs.PlotItemPage.editMergeForm(data, data.dataType, data.pId);
        }
      }
    },
    // 删除分组时清除分组下的标绘数据
    deleteGroupPlotData(data) {
      // 获取旧的
      const oldGraphic = this.$GLOBAL.plotItemLayer?.getGraphicById(
        JSON.parse(data.bimPlanPainting.graphic).id
      );
      // 如果旧在当前图层中
      if (oldGraphic) {
        this.$GLOBAL.plotItemLayer.removeGraphic(oldGraphic);
      } else {
        // 没有去查,首先删除图层上可能被创建过的标绘
        plotOperation.operationPlotData(false, data.id);
      }
    },
    // 删除标绘
    deletePlot(data) {
      // 公共标绘校验
      const params = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        businessType: "BimPlanPainting",
        businessId: data.id,
      };
      plotCheckBeforeAddList(params).then((res) => {
        if (!res.data.data) {
          this.$confirm("确认删除？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            // 发送请求进行后台删除
            deteleBimPlottedData({ id: data.id }).then((res) => {
              // 获取旧的
              const oldGraphic = this.$GLOBAL.plotItemLayer?.getGraphicById(
                JSON.parse(data.bimPlanPainting.graphic).id
              );
              // 如果旧在当前图层中
              if (oldGraphic) {
                this.$GLOBAL.plotItemLayer.removeGraphic(oldGraphic);
              } else {
                // 没有去查,首先删除图层上可能被创建过的标绘
                plotOperation.operationPlotData(false, data.id);
              }
              this.$notify({
                title: `删除成功！`,
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.plotItemShow = false;
              this.currentNode = null;
              this.getData();
            });
          });
        } else {
          // 通知栏
          this.$message({
            showClose: true,
            message: `该资源在【${res.data.data}】等场景中被使用，无法删除，请检查`,
            duration: 0,
            type: "error",
          });
        }
      });
    },
    // 打开文件资源
    addImgResouces() {
      if (!this.currentNode) {
        return this.$notify({
          title: `请先选择分组`,
          message: "",
          type: "warning",
          duration: 960,
          offset: 320,
        });
      }
      this.newPageShow = false;
      this.plotItemShow = false;
      this.imageResourcesShow = true;
    },
    // 行点击事件
    nodeClick(e) {
      this.imageResourcesClose();
      if (e.parentId === 0) {
        this.plotItemClose();
        this.currentNode = e.id;
      } else {
        this.currentNode = e.parentId;
        // 这里判断是为了新增或者修改后立即操作
        const graphic = this.$GLOBAL.plotItemLayer?.getGraphicById(
          JSON.parse(e.bimPlanPainting.graphic).id
        );
        // 有旧id 并且在图层直接飞
        if (graphic) {
          graphic.flyTo();
        } else {
          this.$refs.PlotItemPage.deletePlotItemLayer();
          plotOperation.flyToPlot(e.id, "fly");
        }
      }
    },
    // 关闭标绘
    plotItemClose() {
      this.plotItemShow = false;
      this.modalNode.plotItem.head.fold.state = true;
      this.$nextTick(() => {
        this.$refs.plotTree.$refs.modalTree[0].setCurrentKey(this.currentNode);
      });
    },
    // 关闭整体标绘分组
    plotItem_click() {
      this.$emit("plotItemClose", "plotItem");
    },
    // 关闭资源
    imageResourcesClose() {
      this.imageResourcesShow = false;
    },
    // 勾选框事件
    checkBoxClick(e, isCheck, arr) {
      if (isCheck) {
        this.checkedIds.push(e.id);
      } else {
        this.checkedIds.forEach((item, index) => {
          if (item === e.id) {
            this.checkedIds.splice(index, 1);
          }
        });
      }
      if (e.children.length === 0) {
        // 创建和删除标绘
        plotOperation.operationPlotData(isCheck, e.id);
      }
    },
  },
};
